(() => {
  if (customElements.get('c-featured-products')) return;

  customElements.define('c-featured-products', class extends HTMLElement {
    connectedCallback() {
      this.disconnectedCallback();
      const scroller = this.querySelector('.product-list__inner');
      const previous = this.querySelector('[data-action="prev"]');
      const next = this.querySelector('[data-action="next"]');
      if (!scroller || !previous || !next) return;

      const updateNavigation = () => {
        const position = Math.abs(scroller.scrollLeft);
        previous.disabled = position <= 1;
        next.disabled = position + scroller.clientWidth >= scroller.scrollWidth - 1;
      };
      const scroll = (direction) => {
        const directionFlip = getComputedStyle(scroller).direction === 'rtl' ? -1 : 1;
        scroller.scrollBy({
          left: scroller.clientWidth * direction * directionFlip,
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
      };

      this.navigationController = new AbortController();
      const { signal } = this.navigationController;
      previous.addEventListener('click', () => scroll(-1), { signal });
      next.addEventListener('click', () => scroll(1), { signal });
      scroller.addEventListener('scroll', updateNavigation, { passive: true, signal });
      this.resizeObserver = new ResizeObserver(updateNavigation);
      this.resizeObserver.observe(scroller);
      updateNavigation();
    }

    disconnectedCallback() {
      this.navigationController?.abort();
      this.resizeObserver?.disconnect();
    }
  });
})();
